export * from '@datadog/browser-rum-slim'
